import type { Strings } from '../index.ts';
import { unreadable } from './shared.ts';

/**
 * Die Beliebt-Seite und der Trends-Abschnitt darauf.
 *
 * `noun` ist beide Male der Name der Liste, weil die Sätze in `problem` ihn als Substantiv einsetzen.
 * Er bleibt deshalb im Nominativ und die Sätze sind so gebaut, dass sie mit ihm auskommen.
 */
export const feed: Strings['feed'] = {
  popular: {
    heading: 'Beliebt',
    lede: 'Was Leute auf dieser Instanz sehen, das Neueste zuerst. Es ist keine YouTube-weite Rangliste.',
    emptyTitle: 'Noch nichts Beliebtes',
    emptyDetail:
      'Beliebt entsteht daraus, was die Besucher dieser Instanz selbst ansehen, eine ruhige Instanz hat also eine leere Liste. Der Trends-Abschnitt darüber kommt von YouTube und hängt nicht davon ab.',
    noun: 'Beliebt',
    unreadableTitle: 'Diese Liste konnte nicht gelesen werden',
  },
  trending: {
    heading: 'Trends',
    lede: 'Die Trendliste von YouTube, für die auf dieser Instanz eingestellte Inhaltsregion.',
    emptyTitle: 'Trends ist leer',
    emptyDetail:
      'Es kam nichts zurück, was meistens bedeutet, dass YouTube die Liste nicht geliefert hat.',
    noun: 'Trends',
    unreadableTitle: 'Dieser Feed konnte nicht gelesen werden',
  },

  allDropped: 'Die Instanz hat geantwortet, und nichts darin ließ sich anzeigen.',

  problem: {
    notFoundTitle: (noun) => `Diese Instanz hat kein ${noun}`,
    notFoundDetail: 'Es wird hier nicht angeboten. Manche Instanzen lassen Teile der App weg.',
    unreadableTitle: (noun) => `${noun} konnte nicht gelesen werden`,
    unreadable: unreadable(''),
    disabledTitle: (noun) => `${noun} ist auf dieser Instanz abgeschaltet`,
    disabledDetail: 'Die Administration hat es abgeschaltet. Jede andere Seite arbeitet normal.',
  },

  loading: (heading) => `${heading} wird geladen…`,
  region: (code) => `Region ${code}.`,
};
